import React from 'react';
import { useQuery } from '@apollo/client';
import { ErrorComponents } from '@css-xp/base';
import { generatedTypesNew } from '@css-xp/graphtypes';
import { LoadingIndicator } from '@atlassian/temp-loading-indicator';
import { fetchPaymentMethodsForTransactionAccount } from '../queries/fetch-payment-methods-for-transaction-account';
import './get-account-balance.scss';

const GetAccountBalance = ({ transactionAccountId }: { transactionAccountId: string }) => {
  const { data, loading, error } = useQuery<
    generatedTypesNew.FetchPaymentMethodsForTransactionAccountQuery,
    generatedTypesNew.FetchPaymentMethodsForTransactionAccountQueryVariables
  >(fetchPaymentMethodsForTransactionAccount, {
    variables: { id: transactionAccountId ?? '' },
    fetchPolicy: 'no-cache',
  });

  if (error) return <ErrorComponents.GenericErrorPage error={error} />;

  const accountCreditBalance = data?.transactionAccount?.customerBalances?.usd ?? 0;

  return (
    <div className={'transaction-account-balance-section'}>
      <div className="account-credit">
        <div className="form-header">Account balance</div>
        {loading ? (
          <div className="loading">
            <LoadingIndicator size="medium" />
          </div>
        ) : (
          <div className="acb-value">USD {Math.abs(accountCreditBalance).toFixed(2)}</div>
        )}
      </div>
    </div>
  );
};

export default GetAccountBalance;
